module.exports = __webpack_public_path__ + "img/a.d4520a3a.jpg";